import { request } from '@/services/index'

export const state = {
  isLoading: false,
  userGroupDetail: [],
  connectionDetail: [],
  userMaxNum: 0,
  connectionCreate: {
    success: false,
    data: {},
  },
}

export const mutations = {
  SET_IS_LOADING(state) {
    state.connectionDetail = []
    state.isLoading = true
  },
  SET_USER_GROUP_DETAIL(state, newValue) {
    state.isLoading = false
    state.userGroupDetail = newValue
  },
  SET_CONNECTION_DETAIL(state, newValue) {
    state.isLoading = false
    state.connectionDetail = newValue
    state.connectionCreate = {
      success: false,
      data: {},
    }
  },
  SET_USER_MAX_NUM(state, newValue) {
    state.isLoading = false
    state.userMaxNum = newValue
  },
  SET_CONNECTION_CREATE(state, newValue) {
    state.isLoading = false
    state.connectionCreate = newValue
  },
}

export const getters = {
  getIsLoading(state) {
    return state.isLoading
  },
  getUserGroupDetail(state) {
    return state.userGroupDetail || []
  },
  getListSettingUser(state) {
    return state.connectionDetail || []
  },
  getUserMaxNum(state) {
    return state.userMaxNum
  },
  updateListSettingUser(state) {
    return state.connectionCreate.data
  },
  updateListSettingSuccess(state) {
    return state.connectionCreate.success
  },
}

export const actions = {
  async getUserGroupList({ commit }) {
    commit('SET_IS_LOADING')
    return request({
      endpoint: '/api/user_group/detail',
      payload: {},
    }).then((response) => {
      const results = response.data
      commit('SET_USER_GROUP_DETAIL', results)
      return results
    })
  },
  async getListSettingParams({ commit }) {
    commit('SET_IS_LOADING')
    return request({
      endpoint: '/api/connection/detail',
      payload: {},
    }).then((res) => {
      const result = res.data
      commit('SET_CONNECTION_DETAIL', result)
      return result
    })
  },
  async getUserMaxNumParams({ commit }) {
    commit('SET_IS_LOADING')
    return request({
      endpoint: '/api/user/max_num',
      payload: {},
    }).then((res) => {
      const result = res.max_user_num
      commit('SET_USER_MAX_NUM', result)
      return result
    })
  },
  async updateListSettingParams({ commit }, params) {
    commit('SET_IS_LOADING')
    return request({
      endpoint: '/api/connection/create',
      payload: params,
      isDisplaySnackbar: true,
    })
      .then((res) => {
        const result = {}
        result.data = res.data
        result.success = true
        commit('SET_CONNECTION_CREATE', result)
        return result
      })
      .catch(() => {
        const result = {}
        result.data = {}
        result.success = false
        commit('SET_CONNECTION_CREATE', result)
        return result
      })
  },
}
